import { useAuth } from '../context/AuthContext';
import './EventCard.css';
import { useState, useEffect } from 'react';

function EventCard({ event, onEdit, onDelete }) {
	const { orgData } = useAuth();
	const [imageLoaded, setImageLoaded] = useState(false);

	const truncatedDescription =
		event.description.length > 200
			? `${event.description.substring(0, 197)}...`
			: event.description;

	const primaryColor = orgData?.primaryColor || '#3388B3';

	const cardStyle = {
		backgroundColor: 'transparent',
		borderColor: primaryColor,
		borderWidth: '2px',
		borderStyle: 'solid',
	};

	const buttonStyle = {
		backgroundColor: primaryColor,
	};

	const preloadImage = (url) => {
		if (!url) return;
		const img = new Image();
		img.onload = () => setImageLoaded(true);
		img.src = url;
	};

	useEffect(() => {
		if (event.image) {
			setImageLoaded(false);
			preloadImage(event.image);
		}
	}, [event.image]);

	return (
		<div
			className='event-card'
			style={cardStyle}>
			{/* Ghost loader and background image only shown if image exists */}
			{event.image && (
				<>
					{!imageLoaded && (
						<div className='event-card-ghost'>
							<div className='ghost-gradient'></div>
						</div>
					)}
					<div
						className={`event-card-background ${
							imageLoaded ? 'loaded' : ''
						}`}
						style={{
							backgroundImage: `url(${event.image})`,
						}}
					/>
				</>
			)}
			<div className='card-overlay'>
				<div className='card-header'>
					<div className='icon-container'>
						<span
							className='material-icons'
							style={{ color: primaryColor }}>
							event
						</span>
						<span className='card-type'>Event</span>
					</div>
				</div>

				<h3 className='card-title'>{event.name}</h3>
				<p className='card-description'>{truncatedDescription}</p>

				<div className='event-details'>
					<div className='location-container'>
						<span className='material-icons'>location_on</span>
						<span className='location-text'>{event.location}</span>
					</div>
					<div className='rsvp-container'>
						<span className='material-icons'>group</span>
						<span className='rsvp-text'>
							RSVP Count = {event.rsvpUsers?.length || 0}
						</span>
					</div>
				</div>

				<div className='card-footer'>
					<div className='date-container'>
						<span className='material-icons'>event</span>
						<span className='date-text'>
							{new Date(event.startDate).toLocaleDateString(
								'en-US',
								{
									month: 'numeric',
									day: 'numeric',
									year: 'numeric',
								}
							)}{' '}
							-{' '}
							{new Date(event.endDate).toLocaleDateString(
								'en-US',
								{
									month: 'numeric',
									day: 'numeric',
									year: 'numeric',
								}
							)}
						</span>
					</div>
				</div>

				<div className='card-actions'>
					<button
						className='card-button edit-button'
						onClick={() => onEdit(event)}
						style={buttonStyle}>
						<span className='material-icons'>edit</span>
						Edit
					</button>
					<button
						className='card-button delete-button'
						onClick={() => onDelete(event.id)}
						style={buttonStyle}>
						<span className='material-icons'>delete</span>
						Delete
					</button>
				</div>
			</div>
		</div>
	);
}

export default EventCard;
